import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-rating-modal',
    templateUrl: './rating-modal.component.html',
    styleUrls: ['./rating-modal.component.scss'],
    standalone: false
})
export class RatingModalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
